<template>
  <div class="job-posting">
    <div class="job-opening-section text-center">
      <div class="row">
        <div class="col-md-12 text-center mb-2">
          <h4>Current Job Openings</h4>
          <hr class="w-80" />
        </div>
      </div>
      <div class="row mx-2">
        <!-- justify-content-center -->
        <small
          v-for="(jobItem, index) in Finult_Job_Posting"
          :key="index"
          class="col-sm-6 col-md-6 col-lg-4 my-2"
        >
          <div class="card custom-card job-listing-container">
            <p class="small ucase job-location">
              <span class="corporate-semibold">{{ jobItem.country }}</span>
              <span class="vertical-divider"></span>
              <span class="corporate-semibold job-city-state">{{
                jobItem.city
              }}</span>
            </p>
            <div class="custom-card-body">
              <h5 class="card-title ">{{ jobItem.job_title }}</h5>
              <div class="category">{{ jobItem.domain }}</div>
              <div class="text">
                <Strong>Job Description:</Strong>
                <ul>
                  <li v-for="(jdItem, index) in jobItem.job_desc" :key="index">
                    {{ jdItem }}
                  </li>
                </ul>
              </div>
              <div class="text">
                <Strong>Required Qualification:</Strong>
                {{ jobItem.qualification }}
              </div>
              <div class="text">
                <i class="fa fa-briefcase"></i> {{ jobItem.experience }}
                <span class="vertical-divider"></span>
                <i class="fas fa-rupee-sign"></i>
                <span> {{ jobItem.salary }}</span>
              </div>
            </div>
          </div>
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import jsonData from "@/components/json/Finult_Job_Posting.json";
import "@/assets/css/finult-pages.css";

export default {
  name: "JobPosting",
  metaInfo: {
    title: "Job Openings"
  },
  data() {
    return {
      Finult_Job_Posting: []
    };
  },
  created() {
    console.log(this.$useFirestore);
    if (this.$useFirestore) {
      this.Finult_Job_Posting = this.$options.filters.getFireStoreRecords(
        "Finult_Job_Posting"
      );
    } else {
      this.Finult_Job_Posting = jsonData.Finult_Job_Posting;
    }
  }
};
</script>
